module.exports = __webpack_public_path__ + "static/media/girl-writing.102f6185.png";